import { FileCog, PackageX, Shapes, Tags, Warehouse } from 'lucide-react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../../components/settings/SettingsMenu';

/*
  What Evidence Management configures — the places evidence is kept, the words an item is
  described in, and which files it accepts.
  Each row is a different module with its own key, so the page is gated on holding ANY of them.
  A row added here owes its key to the route's `anyOf` and the sidebar's `anyPermission` in the
  same change.
*/
const ENTRIES: SettingsMenuEntry[] = [
  {
    key: 'storage-locations',
    label: 'Storage Locations',
    description: 'The evidence rooms, vaults and cabinets evidence is kept in.',
    icon: Warehouse,
    to: '/evidence/settings/storage-locations',
    permission: 'evidence-storage-locations.read',
  },
  {
    key: 'kinds',
    label: 'Kinds',
    description: 'Physical, digital and the other kinds of evidence — and whether each is kept as a file.',
    icon: Shapes,
    to: '/evidence/settings/kinds',
    permission: 'evidence-kinds.read',
  },
  {
    key: 'types',
    label: 'Types',
    description: 'What an item of evidence is — a knife, a substance, a phone.',
    icon: Tags,
    to: '/evidence/settings/types',
    permission: 'evidence-types.read',
  },
  {
    key: 'disposal-types',
    label: 'Disposal Types',
    description: 'How evidence is disposed of — burned, returned to its owner, forfeited.',
    icon: PackageX,
    to: '/evidence/settings/disposal-types',
    permission: 'evidence-disposal-types.read',
  },
  {
    key: 'file-types',
    label: 'File Types',
    description: 'Which kinds of file are accepted as evidence, and how large each may be.',
    icon: FileCog,
    to: '/evidence/settings/file-types',
    permission: 'evidence-file-types.read',
  },
];

export function EvidenceSettingsPage() {
  return (
    <div className="flex h-full min-h-0 flex-col bg-slate-100">
      <Breadcrumb segments={['Evidence Management', 'Settings']} />
      <div className="modern-scrollbar min-h-0 flex-1 overflow-y-auto overflow-x-hidden p-4">
        <div className="mx-auto max-w-3xl">
          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
